import type { HotkeySequence } from '@tanstack/react-hotkeys'

export const HOTKEY_TOGGLE_HOTKEYS_DIALOG = { key: '?' } as const
export const HOTKEY_OPEN_SEARCH = {
	slash: '/',
	modK: 'Mod+K',
} as const

export const HOTKEY_GOTO_HOME = ['G', 'H'] as const satisfies HotkeySequence
export const HOTKEY_GOTO_BLOG = ['G', 'B'] as const satisfies HotkeySequence
export const HOTKEY_GOTO_CHATS = ['G', 'C'] as const satisfies HotkeySequence
export const HOTKEY_GOTO_CALLS = ['G', 'A'] as const satisfies HotkeySequence
export const HOTKEY_GOTO_COURSES = ['G', 'O'] as const satisfies HotkeySequence
export const HOTKEY_GOTO_DISCORD = ['G', 'D'] as const satisfies HotkeySequence
export const HOTKEY_GOTO_ABOUT = ['G', 'U'] as const satisfies HotkeySequence
export const HOTKEY_GOTO_TALKS = ['G', 'T'] as const satisfies HotkeySequence
export const HOTKEY_GOTO_TESTIMONY = [
	'G',
	'Y',
] as const satisfies HotkeySequence
export const HOTKEY_GOTO_TRANSPARENCY = [
	'G',
	'P',
] as const satisfies HotkeySequence
export const HOTKEY_GOTO_RESUME = ['G', 'R'] as const satisfies HotkeySequence
export const HOTKEY_GOTO_KODY = ['G', 'K'] as const satisfies HotkeySequence
export const HOTKEY_GOTO_SEARCH = ['G', 'S'] as const satisfies HotkeySequence

export type HotkeysHelpCombo =
	| { kind: 'hotkey'; hotkey: string }
	| { kind: 'sequence'; keys: Array<string> }

export type HotkeysHelpItem = {
	description: string
	combos: Array<HotkeysHelpCombo>
}

export type HotkeysHelpGroup = {
	title: string
	items: Array<HotkeysHelpItem>
}

function getSequenceDisplayKeys(sequence: ReadonlyArray<string>) {
	return sequence.map((key) => key.toLowerCase())
}

export const HOTKEYS_HELP_GROUPS = [
	{
		title: 'General',
		items: [
			{
				description: 'Show keyboard shortcuts',
				combos: [{ kind: 'hotkey', hotkey: '?' }],
			},
			{
				description: 'Close dialog',
				combos: [{ kind: 'hotkey', hotkey: 'Escape' }],
			},
		],
	},
	{
		title: 'Search',
		items: [
			{
				description: 'Focus search',
				combos: [
					{ kind: 'hotkey', hotkey: HOTKEY_OPEN_SEARCH.slash },
					{ kind: 'hotkey', hotkey: HOTKEY_OPEN_SEARCH.modK },
				],
			},
		],
	},
	{
		title: 'Navigation',
		items: [
			{
				description: 'Go to home',
				combos: [
					{ kind: 'sequence', keys: getSequenceDisplayKeys(HOTKEY_GOTO_HOME) },
				],
			},
			{
				description: 'Go to work',
				combos: [
					{
						kind: 'sequence',
						keys: getSequenceDisplayKeys(HOTKEY_GOTO_COURSES),
					},
				],
			},
			{
				description: 'Go to blog',
				combos: [
					{ kind: 'sequence', keys: getSequenceDisplayKeys(HOTKEY_GOTO_BLOG) },
				],
			},
			{
				description: 'Go to about',
				combos: [
					{ kind: 'sequence', keys: getSequenceDisplayKeys(HOTKEY_GOTO_ABOUT) },
				],
			},
			{
				description: 'Go to resume',
				combos: [
					{
						kind: 'sequence',
						keys: getSequenceDisplayKeys(HOTKEY_GOTO_RESUME),
					},
				],
			},
			{
				description: 'Go to contact',
				combos: [
					{ kind: 'sequence', keys: getSequenceDisplayKeys(HOTKEY_GOTO_CALLS) },
				],
			},
			{
				description: 'Go to search',
				combos: [
					{
						kind: 'sequence',
						keys: getSequenceDisplayKeys(HOTKEY_GOTO_SEARCH),
					},
				],
			},
		],
	},
] as const satisfies Array<HotkeysHelpGroup>
